import { CollapsibleCardProps } from '../types';
import { Box, CardActions, CardContent } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';
import { Button } from '../../../../interaction/Buttons/Default Button/Button';
import { TwoColumnBox } from '../../../ContentContainers/TwoColumnBox';
import './CollapsibleCardContent.scss';

export type CollapsibleCardContentProps = Pick<
  CollapsibleCardProps,
  | 'twoColumn'
  | 'collapsible'
  | 'fullWidth'
  | 'defaultClosed'
  | 'children'
  | 'cardActions'
  | 'isCompact'
  | 'cardActionRightComponent'
>;

export const CollapsibleCardContent = ({
  twoColumn,
  fullWidth,
  children,
  cardActions,
  isCompact,
  cardActionRightComponent,
}: CollapsibleCardContentProps) => {
  const CardContentComponent = twoColumn ? TwoColumnBox : Box;

  return (
    <CardContent
      sx={{
        ...(fullWidth && { paddingLeft: '0px', paddingRight: '0px' }),
        ...(isCompact && { paddingTop: '8px' }),

        '&.MuiCardContent-root:last-child': {
          paddingBottom: '20px',
        },
      }}
    >
      <CardContentComponent>
        <Fragment>{children}</Fragment>
      </CardContentComponent>
      {(!!cardActions?.length || cardActionRightComponent) && (
        <CardActions
          sx={{ paddingLeft: '16px', paddingBottom: '0px' }}
          className="card-footer"
        >
          {!!cardActions?.length && (
            <div className="card-footer-left">
              {cardActions.map(action => (
                <Button
                  key={action.text}
                  variant={action.variant || 'text'}
                  onClick={action.onClick}
                  startIcon={action.startIcon || null}
                  debounced
                >
                  {action.text}
                </Button>
              ))}
            </div>
          )}

          {cardActionRightComponent && (
            <div className="card-footer-right">{cardActionRightComponent}</div>
          )}
        </CardActions>
      )}
    </CardContent>
  );
};
